import React, { memo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { AdaptiveMenu } from './AdaptiveMenu';
import { SEMANTIC_COLORS } from '@/constants/residents/residentColors';

interface ThreadActionsMenuProps {
  visible: boolean;
  onClose: () => void;
  isOwnThread: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onReport: () => void;
  onSave: () => void;
  isSaved: boolean;
}

export const ThreadActionsMenu: React.FC<ThreadActionsMenuProps> = memo(({
  visible,
  onClose,
  isOwnThread,
  onEdit,
  onDelete,
  onReport,
  onSave,
  isSaved,
}) => {
  return (
    <AdaptiveMenu visible={visible} onClose={onClose}>
      <View style={styles.content}>
        {/* Save / Bookmark */}
        <TouchableOpacity style={styles.actionItem} onPress={onSave} activeOpacity={0.7} accessibilityRole="button" accessibilityLabel={isSaved ? 'Unsave thread' : 'Save thread'}>
          <Text style={styles.actionText}>{isSaved ? 'Unsave thread' : 'Save thread'}</Text>
        </TouchableOpacity>

        {isOwnThread ? (
          <>
            <TouchableOpacity style={styles.actionItem} onPress={onEdit} activeOpacity={0.7} accessibilityRole="button" accessibilityLabel="Edit thread">
              <Text style={styles.actionText}>Edit thread</Text>
            </TouchableOpacity>

            <TouchableOpacity style={styles.actionItem} onPress={onDelete} activeOpacity={0.7} accessibilityRole="button" accessibilityLabel="Delete thread">
              <Text style={styles.actionTextDanger}>Delete thread</Text>
            </TouchableOpacity>
          </>
        ) : (
          <TouchableOpacity style={styles.actionItem} onPress={onReport} activeOpacity={0.7} accessibilityRole="button" accessibilityLabel="Report thread">
            <Text style={styles.actionTextDanger}>Report thread</Text>
          </TouchableOpacity>
        )}
      </View>
    </AdaptiveMenu>
  );
});

const styles = StyleSheet.create({
  content: {
    gap: 4,
  },
  actionItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    paddingVertical: 14,
    paddingHorizontal: 4,
    borderRadius: 8,
  },
  actionText: {
    fontSize: 16,
    color: SEMANTIC_COLORS.text.primary,
    fontWeight: '400',
  },
  actionTextDanger: {
    fontSize: 16,
    color: SEMANTIC_COLORS.interactive.danger,
    fontWeight: '400',
  },
});
